// extracted by mini-css-extract-plugin
export default {"container":"Legal_container__EV7mO","closeContainer":"Legal_closeContainer__IutRc"};